import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MyPageSection from "../MyPageSection";
import NotificationMark from "../NotificationMark";
import { IconLogoutSVG } from "../../../assets/img/IconLogoutSVG";
import { useAppSelector } from "../../../redux/hooks";
import { getNotificationsTotal } from "../../../redux/reducers/chat";
import { useMypagePrefetch } from "../../../utils/usePrefetch";
import styles from "./MyPageSetting.module.scss";
import SonicLink from "../../../common/routing/SonicLink";

type Props = {
  settings: Array<{
    link: string;
    title: string;
    icon: any;
    description: string;
  }>;
  logoutHandler: () => void;
  showJikeiAdmin: boolean;
  showAdmin: boolean;
};

const MyPageSetting: React.FC<Props> = (props) => {
  const { settings, logoutHandler, showJikeiAdmin, showAdmin } = props;
  const notifications = useAppSelector(getNotificationsTotal);

  const genSettings = (setting: {
    link: string;
    title: string;
    icon: any;
    description: string;
  }) => {
    const ref = useRef<boolean>();
    const prefetch = useMypagePrefetch(setting.link);

    return (
      <li
        key={setting.title}
        className={styles["p-setting__item"]}
        onMouseEnter={() => {
          if (!ref.current) {
            prefetch();
            ref.current = true;
          }
        }}
      >
        <SonicLink to={setting.link}>
          <div className={styles["p-setting__item-content"]}>
            <div className={styles["p-setting__imgbox"]}>
              <div className={styles["p-setting__imgbox__inner"]}>
                {setting.icon}
              </div>
              {/* <img src={img} className={styles["p-setting__img"]} />*/}
            </div>
            <div>
              <div className={styles["p-setting__title"]}>{setting.title}</div>
              <div className={styles["p-setting__description"]}>
                {setting.description}
              </div>
            </div>
            {setting.title === "チャット" && notifications > 0 && (
              <NotificationMark />
            )}
          </div>
          <FontAwesomeIcon icon={["fal", "chevron-right"]} />
        </SonicLink>
      </li>
    );
  };

  return (
    <section className={styles["p-setting"]}>
      <MyPageSection title={"SETTING / EDIT"} />
      <ul className={styles["p-setting__container"]}>
        {settings.map((item) => genSettings(item))}
        <li className={styles["p-setting__item"]}>
          <button
            type="button"
            className={styles["p-setting__link"]}
            onClick={() => logoutHandler()}
          >
            <div className={styles["p-setting__item-content"]}>
              <div className={styles["p-setting__imgbox"]}>
                <div className={styles["p-setting__imgbox__inner"]}>
                  <IconLogoutSVG width={36.304} height={29.473} />
                </div>
              </div>
              <div className={styles["p-setting__title-logout"]}>
                ログアウト
              </div>
            </div>
            <FontAwesomeIcon icon={["fal", "chevron-right"]} />
          </button>
        </li>
      </ul>
      {showJikeiAdmin ? (
        <div className={styles["p-setting__kanri"]}>
          <SonicLink to="/jikei" className={styles["p-setting__kanri-btn"]}>
            管理画面へ
          </SonicLink>
        </div>
      ) : null}
      {showAdmin ? (
        <div className={styles["p-setting__kanri"]}>
          <SonicLink to="/admin" className={styles["p-setting__kanri-btn"]}>
            SELeCT管理画面へ
          </SonicLink>
        </div>
      ) : null}
    </section>
  );
};

export default MyPageSetting;
